import React from 'react'

function FeaturesOne() {
  return (
    <div>
      <section className="features-one features-seven">
        <div className="container">
          <div className="features-seven-title-box">
            <div className="features-one-shape-1" />
            <div className="features-one-shape-2" />
            <div
              className="section-title text-center wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <h2>
                Popular Digital Marketing Services to Build your Business
              </h2>
            </div>
            <div
              className="section-details text-center wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <p>
                Digital marketing &amp; advertising approach focuses on
                capturing the essential
              </p>
            </div>
          </div>
          <div className="features-seven-detail-box">
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="features-one-box features-one-box-1 wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <div className="features-one-icon-box icon-box-1">
                    <i className="icon-bullhorn" />
                  </div>
                  <div className="features-one-title-box">
                    <h3>Paid Media Marketing</h3>
                  </div>
                  <div className="features-one-detail-box">
                    <p>
                      Sed persiciat undomnis voluptate to doloremque
                      laudantiue
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="features-one-box features-one-box-2 wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="features-one-icon-box icon-box-2">
                    <i className="icon-laptop-code" />
                  </div>
                  <div className="features-one-title-box">
                    <h3>Digital Product Marketing</h3>
                  </div>
                  <div className="features-one-detail-box">
                    <p>
                      Sed persiciat undomnis voluptate to doloremque
                      laudantiue
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="features-one-box features-one-box-3 wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="500ms"
                >
                  <div className="features-one-icon-box icon-box-3">
                    <i className="icon-envelopes-bulk" />
                  </div>
                  <div className="features-one-title-box">
                    <h3>SMM &amp; Content marketing</h3>
                  </div>
                  <div className="features-one-detail-box">
                    <p>
                      Sed persiciat undomnis voluptate to doloremque
                      laudantiue
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default FeaturesOne
